<script setup lang="ts">
import IconeBds from "assets/img/icone_BDS.png";
</script>
<template>
    <div class="arquivo">
        <div class="comments">
            <h3>{{ translate.commentBox }}</h3>
            <div v-if="commentsAll">
                <swiper 
                    :slidesPerView="1"
                    :spaceBetween="20"
                    :pagination="{dynamicBullets: true, clickable: true,}"
                    :breakpoints="{
                        '769': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        },
                        '1300': {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        },
                    }"
                    :modules="modules"
                    class="mySwiperComments"
                    style="--swiper-pagination-color: black; 
                            --swiper-pagination-bullet-inactive-color: black;
                            --swiper-pagination-bullet-size: 12px;
                            --swiper-pagination-bottom:0px">
                    <swiper-slide v-for="(comment, index) in commentsAll" :key="index">

                        <div class="comment-body mt-3">
                            <div class="cabecalho mb-2">
                                <img v-if="comment.ativo == 'true'" :src="IconeBds" alt="Assinante" title="Assinante">
                                <strong class="name">{{ comment.user.nickname ?? comment.user.name }}</strong> {{ translate.wroteOn }} {{ comment.date }}:
                            </div>
                            <div v-if="summary">
                                {{ comment.comment.slice(0, 300) }}
                                <a href="#" class="read" v-if="comment.comment.length > 300" @click.prevent="summary = false">... {{ translate.seeMoreComment }}</a>
                            </div>
                            <div v-else>
                                {{ comment.comment }}
                                <a href="#" class="read" v-if="comment.comment.length > 300" @click.prevent="summary = true">... {{ translate.seeLessComment }}</a>
                            </div>

                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { dataFakeType } from './commentsFake'
import api from '../../api'

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

// import required modules
import { Pagination } from 'swiper';

export default {
    name: 'LastCommentsMobile',
    components: { Swiper, SwiperSlide },
    props: ['translate'],
    data() {
        return {
            commentsAll: [] as Array<dataFakeType>,
            modules: [Pagination],
            summary: true,
        }
    },
    methods: {
        async getComments() {
        api.get('v1/blog/getCommentsAllBlogs', { headers:{'X-Custom-Data': this.$cookies.isKey('commentUser') ? this.$cookies.get('commentUser') : ''}}).then(({data}) => {
          this.commentsAll = data.comments
        })
      }
    },
    created() {
        this.getComments()
    }
}
</script>
<style scoped lang="css">

.swiper {
  width: 100%;
}

.swiper-slide {
    min-height:120px;
}
>>> .swiper-wrapper {
  margin-bottom: 30px;
}

h3 {
  color: #000000;
  font-family: 'Roboto-Medium';
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
  text-align: start;
  margin-top: 10px;
}

.arquivo {
    margin-top: 50px;
}

.arquivo div.comments {
    border: 1px solid #dfdfdf;
    padding: 18px;
    padding-left: 20px;
}

.arquivo div.comments img {
    width: 12px;
    margin-right: 5px;
    object-fit: cover;
}

.name {
    color: black;
    font-size: small;
}

.comment-body {
  color: #5b5858;
  font-family: 'Roboto-Regular';
  font-size: 13px;
  letter-spacing: 0;
  line-height: 15px;
}

.read {
    font-family: 'Roboto-Regular';    
    color: #444444;
    font-size: 13px;
}
</style>